// Centralized city list for FPV Connect
export const CITY_LIST = [
  'Mumbai',
  'Pune',
  'Delhi',
  'Bangalore',
  'Hyderabad',
  'Chennai',
  'Kolkata',
  'Ahmedabad',
  'Jaipur',
  'Chandigarh',
  'Lucknow'
]; 